import React from "react";
import { formatEUR } from "@/lib/constants";
import { ShieldCheck } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Interactive 3% insurance calculator used inside the booking flow.
export function InsuranceCalculator({ enabled, setEnabled, value, setValue }) {
  const premium = enabled ? Math.round((Number(value) || 0) * 0.03 * 100) / 100 : 0;
  return (
    <div className="border border-border rounded-sm p-4 bg-muted/40" data-testid="insurance-calculator">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <ShieldCheck size={18} className="text-primary" />
          <span className="font-display font-semibold">Assicura la spedizione</span>
        </div>
        <Switch checked={enabled} onCheckedChange={setEnabled} data-testid="insurance-toggle" />
      </div>
      <p className="text-xs text-muted-foreground mt-1">
        Polizza stipulata con compagnia esterna — <strong>3% del valore assicurato</strong>.
      </p>
      {enabled && (
        <div className="mt-4 space-y-3 ts-rise">
          <div>
            <Label className="text-xs">Valore merce (€)</Label>
            <Input type="number" min="0" value={value} onChange={(e) => setValue(e.target.value)}
              placeholder="es. 5000" className="rounded-sm mt-1" data-testid="insurance-value-input" />
          </div>
          <div className="flex items-center justify-between border-t border-border pt-3">
            <span className="label-eyebrow text-muted-foreground">Costo polizza (3%)</span>
            <span className="font-display text-xl font-bold text-accent" data-testid="insurance-premium">{formatEUR(premium)}</span>
          </div>
        </div>
      )}
    </div>
  );
}
